import { Component, OnInit, TemplateRef, EventEmitter, Output, Input, SecurityContext, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PHBHPFeaturePackageAuthorizationService } from '../ph-bhp-feature-package-authorization.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AuthenticateData } from '../Models/Models';
import { environment } from 'src/environments/environment';
import { ProfileService } from 'profile';
import { ClientData } from 'src/app/user/Models/ClientData';
import { CookiesService } from 'src/app/services/cookies.service';
import { checkLocalizationLang } from 'ph-bhp-feature-packages/ph-bhp-feature-package-sopmanagement/lib/translation.utilities';
import { TranslationKeys } from 'ph-bhp-localization';
import { TranslateService } from '@ngx-translate/core';
import { FiltersService } from 'src/app/services/filters.service';

@Component({
  selector: 'lib-ph-bhp-login',
  templateUrl: './ph-bhp-login.component.html',
  styleUrls: ['./ph-bhp-login.component.css']
})

export class PHBHPLoginComponent implements OnInit {
  modalRef: BsModalRef;
  signUpUrl = environment.signUpUrl;
  @ViewChild('needRefresh') needRefresModal: TemplateRef<any>;
  @Output() childData = new EventEmitter();
  @Output() changeLanguage = new EventEmitter();
  @Input() clientData: ClientData;
  @Input() isDesktop = true;
  @Input() isUserName = true; // this component is only used once with default value = true
  Langmenu: boolean = false;
  htmlToAddLegalNotice;
  htmlToAddDataProtection;
  showPassword = false;
  formdata: UntypedFormGroup;
  validCredentials = true;
  htmlToAddTerms
  hide = true;
  // this should not be used this way
  placeHolder = "Enter your username";
  lableName = "Username";

  checkModel: boolean = false;
  productVersion: any;
  emitData: any = {
    key: '',
    val: ''
  }
  userId
  resData
  logOutUrl: string;
  campaigns: [] = [];
  translationKeys: typeof TranslationKeys = TranslationKeys;

  public languages = [
    {
      language: this.translationKeys.Label.English,
      value: "en"
    },
    {
      language: this.translationKeys.Label.German,
      value: "de"
    },
    {
      language: this.translationKeys.Label.Hungarian,
      value: "hu"
    },
    {
      language: this.translationKeys.Label.Spanish,
      value: "es"
    },
    {
      language: this.translationKeys.Label.French,
      value: "fr"
    },
    {
      language: this.translationKeys.Label.Italian,
      value: "it"
    },
    {
      language: this.translationKeys.Label.Czeck,
      value: "cs"
    },
    {
      language: this.translationKeys.Label.Slovakian,
      value: "sk"
    },
    {
      language: this.translationKeys.Label.Dutch,
      value: "nl"
    },
    {
      language: this.translationKeys.Label.Catalan,
      value: "ca"
    }, {
      language: this.translationKeys.Label.Portuguese,
      value: "pt"
    },
  ];

  public languageSelected: string;
  public device!: 'tablet' | 'mobile' | 'desktop';

  @Output() popoverLanguageEmit: EventEmitter<Event> = new EventEmitter();

  constructor(
    private modalService: BsModalService,
    private service: PHBHPFeaturePackageAuthorizationService,
    private sanitizer: DomSanitizer,
    private userDetailsService: ProfileService,
    public layoutService: PHBHPLayoutPackageService,
    private translateService: TranslateService,
    private cookies: CookiesService,
    private filtersService: FiltersService) {
  }

  changeSelectLang(lang: string) {
    this.languageSelected = lang;
    this.translateService.use(this.languageSelected);
    localStorage.setItem('selectedlanguage', lang);
  }

  ngOnInit() {
    this.languageSelected = localStorage.getItem('selectedlanguage') || 'en';
    this.logOutUrl = environment.siteUrl + 'login';
    this.formdata = new UntypedFormGroup({
      username: new UntypedFormControl('', Validators.compose([
        Validators.required
      ])),
      password: new UntypedFormControl('', Validators.compose([
        Validators.required
      ])),
    })
    this.service.getProductVersionList().subscribe((res: string) => {
      this.productVersion = res;

    });

    // this.service.getTemplate("legalNotice","de").subscribe((res : any)=>{
    //   this.htmlToAddLegalNotice = this.sanitizer.sanitize(SecurityContext.HTML,res.content);
    // })
    this.service.getTemplate("dataProtection", "de").subscribe((res: any) => {
      this.htmlToAddDataProtection = this.sanitizer.sanitize(SecurityContext.HTML, res.content);
    })
    if (!this.isUserName) {
      this.placeHolder = "Enter your Email";
      this.lableName = "Email";
    }

    this.checkVersion();

  }

  checkVersion() {
    var version = this.cookies.getCookie('version');
    if (version != environment.version) {
      this.cookies.setCookie('version', environment.version, 15);
      this.refreshPage();
    }
  }

  refreshPage() {
    window.location.reload();
  }

  openModal(template: TemplateRef<any>) {
    if (this.isDesktop) {
      this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' }));
    } else {
      this.changeLanguage.emit();
    }
  }
  openLegalModal(template: TemplateRef<any>) {
    if (this.isDesktop) {
      this.modalRef = this.modalService.show(template, {
        animated: true,
        backdrop: 'static',
        class: 'modal-full termsWidth'
      });
    } else {
      this.changeLanguage.emit();
    }
  }

  uppercase(value) {
    switch (value) {
      case 'en': return 'English';
        break;
      case 'de': return 'German';
        break;
      case 'hu': return 'Hungarian';
        break;
      case 'es': return 'Spanish';
        break;
      case 'fr': return 'French';
        break;
      case 'nl': return 'Dutch';
        break;
      case 'cs': return 'Czeck';
        break;
      case 'sk': return 'Slovakian';
        break;
      case 'ca': return 'Catalan';
        break;
      case 'pt': return 'Portuguese';
        break;
    }
  }

  onClickSubmit(val) {
    if (this.formdata.invalid) {
      // this.data.showError(this.data.translatetext('Add all Required Data'));
      return true;
    }

    localStorage.removeItem('campaigns');
    localStorage.removeItem('showLicenseWarning');
    var data: any = {
      "Username": val.username,
      "Password": val.password,
      "ClientID": this.clientData,
      "ClientSecret": "",
      "Scope": ""
    };
    this.layoutService.showLoader = true;
    this.service.logInUser(data).subscribe((res: AuthenticateData) => {
      if (!res.user.isActive) {
        this.layoutService.showError(this.layoutService.translateText('AUTHORIZATION.ERROR_USER_NOT_ACTIVE'));
        this.layoutService.showLoader = false;
        return;
      }

      const role = JSON.parse(res.user.roleName);
      if(role.roleId > 2 &&(!res.institutions || res.institutions.length == 0)){
        this.layoutService.showError(this.layoutService.translateText('AUTHORIZATION.ERROR_NO_INSTITUTIONS'));
        this.layoutService.showLoader = false;
        return;
      }
      localStorage.setItem("token", res.token);
      localStorage.setItem("userData", JSON.stringify(res.user));
      localStorage.setItem("institutions", res.institutions);
      localStorage.setItem("access_token", res.token);
      localStorage.setItem("refresh_token", res.refreshToken);
      localStorage.setItem("campaigns", JSON.stringify(res.campaigns));
      this.emitData = {};
      this.emitData.key = "success";
      this.layoutService.showLoader = false;
      this.resData = res;
      this.userId = res.user.userId;
      this.campaigns = res.campaigns;
      this.filtersService.loadFilters(res.user);
      checkLocalizationLang(this.layoutService.translate, this.layoutService.translate.currentLang, res.user.country);
      this.firstTimeLogin(res);
    });
  }

  firstTimeLogin(res) {
    if (res.user.validationKey == "FirstTimeLogin") {
      this.emitData.key = "FirstTimeLogin";
      this.emitData.val = res;
      this.childData.emit(this.emitData);
    }
    else {
      this.emitData.val = res;
      this.childData.emit(this.emitData);
    }
  }

  onChange(event) {
    this.checkModel = event.target.checked;
  }

  openloginmodal() {
    this.service.policyCheckApi(this.userId).subscribe((res: any) => {
      this.firstTimeLogin(this.resData);
      this.modalRef.hide();
    });
  }

  closemodal() {
    this.modalRef.hide();
  }
  changePassword(): void {
    // window.open(environment.loginAbsoluteUrl, "_blank");
    this.emitData = {};
    this.emitData.key = "forgetpassword";
    this.childData.emit(this.emitData);
  }

  usersignIn(): void {
    this.emitData = {};
    this.emitData.key = "signin";
    this.childData.emit(this.emitData);
  }

  viewPassword() {
    this.showPassword = !this.showPassword;
  }
  signUp() {

  }
  logout() {
    this.userDetailsService.logout();
    window.location.href = this.logOutUrl;
  }
}
